import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DateCellStyling,ContainerStyling,HeadingStyling,ContentCellStyling,TableStyling,TableRowStyling} from './BiogTableStyles';

export default function BiogExhibits(props) {
  const { t } = useTranslation('common');

  return (
    <>
    <Grid2 flexDirection="row" sx={ContainerStyling}>
        <TableContainer>
          <Table sx={TableStyling} aria-label="simple table">
            <TableBody>
              {props.exhibitionList.map((exhib, index) => (
                <TableRow
                  key={exhib.id}
                  sx={TableRowStyling}
                >
                  <TableCell component="td" padding="none" sx={DateCellStyling}>
                    {exhib.year}
                  </TableCell>
                  <TableCell component="td" align="left" padding="none" sx={ContentCellStyling}>
                    <Box sx={{fontWeight : 'bold'}} component='span'>{exhib.institution}</Box>
                    <Box sx={{fontWeight : 'normal'}} component='span'>, {exhib.location}</Box>
                    {!!(exhib.title)?<Box sx={{fontWeight : 'normal',fontStyle:'italic'}} component='span'> - {exhib.title}</Box>:null}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid2>
    </>
  )
}
